import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { FlexByRow, XDivider, YDivider, HalfScreen, FlexGrowOne } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../AppControl/RoutePage'
import { TextField, CheckBox, DateTime, Select, ClearButton, SaveButton, MultiSelectWithCheckboxes, Autocomplete } from 'irmlib/components/FormControls'
import { addFormTemplate } from 'irmlib/components/FormControls/common'
import { OutlinedButton } from 'irmlib/components/Controls'
import { useFormPageHandler, useForceRender } from 'irmlib/hooks'
import * as regx from 'irmlib/components/FormControls/'
import { today } from 'irmlib/common'
import { LocalToast } from 'irmlib/containers'
import { useTranslation } from 'react-i18next'

const countries = [
  { label: 'TUVALU', value: 'TV' },
  { label: 'UGANDA', value: 'UG' },
  { label: 'UKRAINE', value: 'UA' },
  { label: 'UNITED ARAB EMIRATES', value: 'AE' },
  { label: 'UNITED KINGDOM', value: 'GB' },
  { label: 'UNITED STATES', value: 'US' },
]

const selectItems = [
  { value: '10', label: 'demo.select1' },
  { value: '20', label: 'demo.select2' },
  { value: '30', label: 'demo.select3' },
  { value: '40', label: 'demo.select4' },
  { value: '50', label: 'demo.select5' }
]

const selectItems2 = [
  { value: '10', label: 'demo.select1' },
  { value: '30', label: 'demo.select3' },
  { value: '50', label: 'demo.select5' }
]

const formTemplate = [
  {
    label: 'demo.name',
    fieldKey: 'obj.obj1.name',
    defaultValue: '',
    isRequired: true,
    startString: 'demo.anyPretext',
    validator: value => {
      if (value.length > 20) {
        return 'demo.validateFieldErrorMsg'
      }
      return ''
    },
    regx: regx.alphanumericRegex,
    regxError: regx.alphanumericRegexError
  },
  {
    label: 'demo.address',
    fieldKey: 'obj.obj1.address',
    defaultValue: '',
    isRequired: true,
    maxLength: 15
  },
  {
    label: 'demo.selectDemo',
    fieldKey: 'obj.obj1.select',
    defaultValue: '30',
    isRequired: true
  },
  {
    label: 'demo.checkbox',
    fieldKey: 'obj.obj1.check',
    defaultValue: false
  },
  {
    label: 'demo.changeSelectItems',
    fieldKey: 'obj.obj1.check2',
    defaultValue: false
  },
  {
    label: 'demo.dateTimeDemo',
    fieldKey: 'obj.obj1.date',
    defaultValue: '',
    isRequired: true
  },
  {
    label: 'demo.dateTimeDemo',
    fieldKey: 'obj.obj1.date2',
    defaultValue: today,
    isRequired: true
  },
  {
    label: 'demo.dateTimeDemo',
    fieldKey: 'obj.obj1.date3',
    defaultValue: '',
    isRequired: true
  },
  {
    label: 'demo.multiSelectDemo',
    fieldKey: 'obj.obj1.multiSelect',
    defaultValue: [],
    isRequired: true
  },
  {
    label: 'demo.autocompleteDemo',
    fieldKey: 'obj.obj1.autocomplete',
    defaultValue: null,
    isRequired: true
  },
]

const selectAdd = {
  label: 'demo.selectDemo',
  fieldKey: 'obj.obj1.selectAdd',
  defaultValue: '20',
  isRequired: true
}

const textEditAdd = {
  label: 'demo.name',
  fieldKey: 'obj.obj1.textEditAdd',
  defaultValue: '',
  isRequired: true,
  startString: 'demo.anyPretext',
  validator: value => {
    if (value.length > 20) {
      return 'demo.validateFieldErrorMsg'
    }
    return ''
  },
  regx: regx.alphanumericRegex,
  regxError: regx.alphanumericRegexError
}

const VerticalDivider = () =>
  <YDivider height='50px' />

const Buttons = props =>
  <>
    <ClearButton arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton feedBack formTemplate={props.formTemplate} arrRefs={props.arrRefs} postService={props.postService} />
  </>

Buttons.propTypes = {
  arrRefs: PropTypes.array,
  postService: PropTypes.func,
  formTemplate: PropTypes.array,
}

const PageContainer = styled.div`
  width: 100%;
`

// Use the function basehttp.get for the get in your service.
const getService = () => {
  const getObject = {
    obj: {
      obj1: {
        name: 'John Doe',
        address: '1137 6th Street',
        select: '10',
        multiSelect: ['10'],
        check: false,
        check2: false,
        date: '2021-12-31',
        autocomplete: 'UA',
      }
    }
  }
  // This simulates a basehttp.get.
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(getObject)
    }, 2000)
  })
}

const NAME_FIELD = 0
const ADDRESS_FIELD = 1
const SELECT_FIELD = 2
const CHECK_FIELD = 3
const CHECK_FIELD_2 = 4
const DATE_FIELD = 5
const DATE_FIELD2 = 6
const DATE_FIELD3 = 7
const MULTI_SELECT_FIELD = 8
const AUTOCOMPLETE_FIELD = 9

// This has an edit feature. So, a getService must be defined to retrieve the data from the server.
const FormDemoEdit = () => {
  const { t } = useTranslation()
  const newFormFieldList = useRef([])
  const forceRender = useForceRender()
  const refLocalToast = useRef(null)
  const refLocalBusyCursor = useRef(null)
  const [arrRefs, data, isLoaded] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  useEffect(() => {
    if (isLoaded) {
      // Collect any info from data that you might need here.
      // Then if you need to put something into the post object other than field data, use the onBeforePost for the SaveButton. 
    }
  }, [isLoaded])

  // Change other controls by accessing them through the arrRefs.
  const onChangeCheck = value => {
    arrRefs[ADDRESS_FIELD].current.setDisabled(value)
  }

  const onChangeCheck2 = value => {
    const selectField = arrRefs[SELECT_FIELD].current
    if (value) {
      selectField.setSelectItems(selectItems2)
      selectField.setValue('50')
    } else {
      selectField.setSelectItems(selectItems)
      selectField.setValue(formTemplate[SELECT_FIELD].defaultValue)
    }
  }

  // Defined the below in services
  // Use the function uiPost for the post.
  const postService = postObject => {
    const doPost = postObject => {
      // eslint-disable-next-line no-console
      console.log(JSON.stringify(postObject, undefined, 2))
      refLocalToast.current?.successToastOn({ message: t('toast.templateSavedSucessfully'), title: t('routeTitles.createTemplate') })
    }
    return new Promise(resolve => {
      setTimeout(() => resolve(doPost(postObject)), 2000)
    })
  }

  const addFormField = () => {
    const newComponent1 = addFormTemplate({ fieldTemplate: selectAdd, Component: Select, props: { items: selectItems }, arrRefs })
    const newComponent2 = addFormTemplate({ fieldTemplate: textEditAdd, Component: TextField, arrRefs })
    newFormFieldList.current.push(
      <div key={newFormFieldList.current.length}>
        <VerticalDivider />
        <FlexByRow>
          <HalfScreen>
            <FlexGrowOne>
              {newComponent1}
            </FlexGrowOne>
          </HalfScreen>
          <XDivider width='50px' />
          <HalfScreen>
            <FlexGrowOne>
              {newComponent2}
            </FlexGrowOne>
          </HalfScreen>
        </FlexByRow>
      </div>
    )
    forceRender()
  }

  const arr = [...newFormFieldList.current]

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.templateManagement'
      subTitle='routeTitles.createTemplate'
      buttons={<Buttons formTemplate={formTemplate} arrRefs={arrRefs} postService={postService} />}
      rightButtons
    >
      <PageContainer>
        <LocalToast ref={refLocalToast} />
        <FlexByRow>
          <HalfScreen>
            <TextField
              data={data}
              fieldTemplate={formTemplate[NAME_FIELD]}
              ref={arrRefs[NAME_FIELD]}
            />
            <VerticalDivider />
            <TextField
              data={data}
              fieldTemplate={formTemplate[ADDRESS_FIELD]}
              ref={arrRefs[ADDRESS_FIELD]}
            />
            <VerticalDivider />
            <Select
              data={data}
              items={selectItems}
              fieldTemplate={formTemplate[SELECT_FIELD]}
              ref={arrRefs[SELECT_FIELD]}
            />
            <VerticalDivider />
            <MultiSelectWithCheckboxes
              data={data}
              items={selectItems}
              fieldTemplate={formTemplate[MULTI_SELECT_FIELD]}
              ref={arrRefs[MULTI_SELECT_FIELD]}
            />
          </HalfScreen>
          <XDivider width='50px' />
          <HalfScreen>
            <CheckBox
              onChange={onChangeCheck}
              data={data}
              fieldTemplate={formTemplate[CHECK_FIELD]}
              ref={arrRefs[CHECK_FIELD]}
            />
            <VerticalDivider />
            <CheckBox
              onChange={onChangeCheck2}
              data={data}
              fieldTemplate={formTemplate[CHECK_FIELD_2]}
              ref={arrRefs[CHECK_FIELD_2]}
            />
            <VerticalDivider />
            <FlexByRow>
              <FlexGrowOne>
                <DateTime
                  data={data}
                  fieldTemplate={formTemplate[DATE_FIELD2]}
                  ref={arrRefs[DATE_FIELD2]}
                  type='date'
                />
              </FlexGrowOne>
              <XDivider width='20px' />
              <FlexGrowOne>
                <DateTime
                  data={data}
                  fieldTemplate={formTemplate[DATE_FIELD3]}
                  ref={arrRefs[DATE_FIELD3]}
                  type='date'
                />
              </FlexGrowOne>
            </FlexByRow>
            <VerticalDivider />
            <DateTime
              data={data}
              fieldTemplate={formTemplate[DATE_FIELD]}
              ref={arrRefs[DATE_FIELD]}
              type='date'
            />
            <VerticalDivider />  
            <Autocomplete
              data={data}
              options={countries}
              fieldTemplate={formTemplate[AUTOCOMPLETE_FIELD]}
              ref={arrRefs[AUTOCOMPLETE_FIELD]}
            />
          </HalfScreen>
        </FlexByRow>
        {arr}
        <YDivider height='20px' />
        <OutlinedButton onClick={addFormField} noTranslate>Add</OutlinedButton>
      </PageContainer>
    </MainRouteSubRoutePage>
  )
}

export default FormDemoEdit